import React from 'react';
import Nav from './shared/components/nav';
import SiteHead from './shared/components/header';

import './app.css';
import { Route, Switch } from 'react-router-dom';

import Airline from './views/airline';
import Flight from './views/flight';
import Airport from './views/airport';
import Search from './views/search';
import Iata from './views/iata';
import InvoiceReconciliation from './views/invoice';
import Dashboard from './views/dashboard';
import TSC from './views/statementOfTsc';
import FTPCredentials from './views/ftp-credentials'
import Reports from './views/reports'
import Proforma from './views/proforma'
import PaymentUpload from './views/payment-upload'
import UnmatchedPayment from './views/unmatchedPayment';
import MatchPayment from './views/matchPayment';
import PaymentReconciliation from './views/payment-reconciliation';
import PdmReport from './views/pdm-report';
import PdmDataEntry from './views/pdm-data-entry';
import UploadManifest from './views/uploadManifest'
import Workflow from './views/workflow'
import WorkflowUser from './views/workflow/workflowUser'
import IataValidation from './views/iataValidation'
import IataValidationPage from './views/iataValidation/index-validation'
import NotFound from './views/pages/404'
import UnmatchedDomesticPayment from './views/unmatched-domestic-payment';
import MatchDomesticPayment from './views/matchDomesticPayment';

import BilledPerAirport from './views/billedPerAirport' ;
import MakerChecker from './views/makerChecker' ;
import AirlineLocation from './views/airline-location' ;
import FlagMetrics from './views/flagMetrics';
import TicketClassSetup from './views/ticket-class-setup'
// ui elements
import Buttons from './views/ui/buttons';
import Typography from './views/ui/typography';
import Cards from './views/ui/cards';
import Modals from './views/ui/modals';
import Notification from './views/ui/notification';
import Extras from './views/ui/extras';

import SecurityChargeReport from "./views/security-charge-report";
import FinalDestinationReport from "./views/final-destination-report";
import AuditTrails from "./views/audit-trail";
import Wallets from "./views/airline-wallet-history";
import AirlineWallets from "./views/airline-wallet";
import ElasticSyncSearch from "./views/elastic-search-sync";
import DisputeEntry from "./views/dispute-log";
import AVIDashboard from "./views/avicollectDashboard"
import HelpCenter from "./views/help-center"
import UnbilledPassengers from "./views/unbillled-passengers"
import TicketSearch from './views/ticket-search';
import OldBilledPerAirport from './views/oldBilledPerAirport';
import flightOperations from './views/flight-operations';
import PdmEdit from "./views/pdm-data-entry/edit-pdm-panel"
import PassengerLevelData from './views/passenger-level-data';
// forms
// import FormGeneral from './views/forms/general';
// import FormAdvanced from './views/forms/advanced';

// charts
// import Charts from './views/charts';

// tables
// import Tables from './views/tables';

//set localization for the app so that time and datepickers will have a reference for working
import Moment from 'moment';
import momentLocalizer from 'react-widgets-moment';

// Time ago formatter.
import TimeAgo from 'javascript-time-ago'

// Tooltip CSS styles:
import 'react-time-ago/Tooltip.css'

// Load locale-specific relative date/time formatting rules.
import en from 'javascript-time-ago/locale/en'
import { appConstants } from "./_constants";
import { appHelpers } from "./_helpers";

Moment.locale('en');
momentLocalizer();

// Add locale-specific relative date/time formatting rules.
TimeAgo.locale(en);

export default class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = { navMini: false }
    }

    toggleNav = (e) => {
        e.preventDefault();
        this.setState({ navMini: !this.state.navMini });
    };
    hideNav = (e) => {
        e.stopPropagation();
        e.preventDefault();
        this.setState({ navMini: false })
    };

    processForgotPassword = (e) => {
        const url_ = appConstants.RESET_PASSWORD_URL + appHelpers.getActiveUser().access_token;
        window.open(url_, '_blank');
    };

    render() {
        let navMini = this.state.navMini;
        return (
            <div className="app-wrapper">
                <Nav mini={navMini} toggleNav={this.toggleNav} processForgotPassword={this.processForgotPassword} />
                <div className={`content-container ${navMini ? 'full' : ''}`}>
                    {/* dropshadow for mobile nav triggering */}
                    <div className="menu-dropshadow" style={{ display: (navMini ? 'block' : 'none') }} onClick={this.hideNav}></div>
                    <SiteHead toggleNav={this.toggleNav} processForgotPassword={this.processForgotPassword} />
                    <Switch>
                        <Route path='/ui/buttons' component={Buttons} />
                        <Route path='/ui/typography' component={Typography} />
                        <Route path='/ui/cards' component={Cards} />
                        <Route path='/ui/modals' component={Modals} />
                        {/*<Route path='/widgets' component={Widgets}/>*/}
                        <Route path='/ui/notification' component={Notification} />
                        <Route path='/ui/extras' component={Extras} />
                        {/*<Route path='/forms/general' component={FormGeneral}/>*/}
                        {/*<Route path='/forms/advanced' component={FormAdvanced}/>*/}
                        {/*<Route path='/charts' component={Charts}/>*/}
                        {/*<Route path='/tables' component={Tables}/>*/}
                        {/* <Route exact path='/' component={Dashboard} /> */}
                        <Route exact path='/' component={AVIDashboard} />
                        <Route exact path='/timeline' component={Dashboard} />
                        <Route exact path='/upload/manifest' component={UploadManifest} />
                        <Route exact path='/airline' component={Airline} />
                        <Route exact path='/airport' component={Airport} />
                        <Route exact path='/flight' component={Flight} />
                        <Route exact path='/iata' component={Iata} />
                        <Route exact path='/invoice' component={InvoiceReconciliation} />
                        <Route exact path='/tsc' component={TSC} />
                        <Route exact path='/search' component={Search} />
                        <Route exact path='/ftp-credentials' component={FTPCredentials} />
                        <Route exact path='/reports' component={Reports} />
                        <Route exact path='/unmatched-payments' component={UnmatchedPayment} />
                        <Route exact path='/match-payment/:reconId' component={MatchPayment} />
                        <Route exact path='/proforma' component={Proforma} />
                        <Route exact path='/payment-upload' component={PaymentUpload} />
                        <Route exact path="/payment-reconciliation" component={PaymentReconciliation} />
                        <Route exact path="/pdm-report" component={PdmReport} />
                        <Route exact path="/pdm-data-entry" component={PdmDataEntry} />
                        <Route exact path="/workflow" component={Workflow} />
                        <Route exact path="/workflow-user/:workflowId" component={WorkflowUser} />
                        <Route exact path="/unmatched-domestic-payment" component={UnmatchedDomesticPayment} />
                        <Route exact path="/match-domestic/:reconId" component={MatchDomesticPayment} />
                        <Route exact path="/iata-validation" component={IataValidation} />
                        <Route exact path="/iata-validation-page/:id" component={IataValidationPage} />
                        <Route exact path="/billed-per-airport" component={BilledPerAirport} />
                        <Route exact path="/maker-checker" component={MakerChecker} />
                        <Route exact path="/airline-location" component={AirlineLocation} />
                        <Route exact path="/flag-metrics" component={FlagMetrics} />
                        <Route exact path="/ticket-class-setup" component={TicketClassSetup} />
                        <Route exact path="/security-charge-report" component={SecurityChargeReport} />
                        <Route exact path="/final-destination-report" component={FinalDestinationReport} />
                        <Route exact path="/audit-trail" component={AuditTrails} />
                        <Route exact path="/airline-wallet-history" component={Wallets} />
                        <Route exact path="/airline-wallet" component={AirlineWallets} />
                        <Route exact path="/dispute-log" component={DisputeEntry} />
                        <Route exact path="/help-center" component={HelpCenter} />
                        <Route exact path="/elastic-search-sync" component={ElasticSyncSearch} />
                        <Route exact path="/unbilled-passengers" component={UnbilledPassengers} />
                        <Route exact path="/ticket-search" component={TicketSearch} />
                        <Route exact path="/old-billed-per-airport" component={OldBilledPerAirport} />
                        <Route exact path="/flight-operations" component={flightOperations} />
                        <Route path="/pdm-edit" component={PdmEdit} />
                        <Route path="/passenger-level-data" component={PassengerLevelData} />


                        {/*
                        * This should be the last route
                        * Put other routes before it
                        * */}
                        <Route exact path="**" component={NotFound} />
                    </Switch>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/App.js